import React from 'react';
import { Route, useHistory } from 'react-router-dom';
import { RBAC_PERMISSION_LEVEL_NO_ACCESS } from '../constants/RoleConsts';
import './privateRoutes.scss';

const PrivateRoute = ({ component: Component, reloadCurrentUser, loading = () => {}, ...rest }) => {
  const { permissions, accessTypes } = rest;
  const history = useHistory();

  const checkAccessLevel = () => {
    let state = false;
    for (const permission in permissions) {
      if (
        accessTypes.some((val) => val === 'home') ||
        (accessTypes?.some((val) => val === permission) &&
          permissions[permission] > RBAC_PERMISSION_LEVEL_NO_ACCESS)
      ) {
        state = true;
      }
    }
    if (!state) {
      history.push('/access-denied');
    }
    return state;
  };

  return (
    <>
      {checkAccessLevel() && (
        <Route
          {...rest}
          render={(props) => (
            <div className='page-container scroll-styled col pb-2'>
              <div className='h-100 m-0 content'>
                <Component showLoader={loading} {...rest} {...props} />
              </div>
            </div>
          )}
        ></Route>
      )}
    </>
  );
};

export default PrivateRoute;
